import { useCallback, useState } from 'react';
import { SocialPlatform, SocialPostType } from '../promote/types';

export interface SocialPostsFilters {
  /** Undefined: all channels. */
  platform?: SocialPlatform;
  /** Undefined: all types. */
  type?: SocialPostType;
  /** True: only the posts that Music24 published. */
  oursOnly: boolean;
}

const NO_FILTERS: SocialPostsFilters = { oursOnly: false };

/** The three filters of the posts table: the channel, the type and "Published with Music24". */
export function useSocialPostsFilters() {
  const [filters, setFilters] = useState<SocialPostsFilters>(NO_FILTERS);

  const setPlatform = useCallback(
    (platform: SocialPlatform | undefined) => setFilters((current) => ({ ...current, platform })),
    []
  );
  const setType = useCallback(
    (type: SocialPostType | undefined) => setFilters((current) => ({ ...current, type })),
    []
  );
  const toggleOurs = useCallback(() => setFilters((current) => ({ ...current, oursOnly: !current.oursOnly })), []);
  const clear = useCallback(() => setFilters(NO_FILTERS), []);

  const isFiltered = filters.platform !== undefined || filters.type !== undefined || filters.oursOnly;

  return { filters, isFiltered, setPlatform, setType, toggleOurs, clear };
}
